export function numero(valor) {
  if (valor === "" || valor === null || valor === undefined) return 0;
  const texto = String(valor).trim();
  const normalizado = texto.includes(",")
    ? texto.replace(/\./g, "").replace(",", ".")
    : texto;
  return Number(normalizado);
}

export function numeroBR(valor, casas = 1) {
  if (valor === "" || valor === null || valor === undefined) return "";
  const n = numero(valor);
  if (!Number.isFinite(n)) return "";
  return n.toLocaleString("pt-BR", {
    minimumFractionDigits: casas,
    maximumFractionDigits: casas,
  });
}

export function formatarDataBR(dataISO) {
  if (!dataISO) return "-";
  const [ano, mes, dia] = String(dataISO).split("-");
  if (!ano || !mes || !dia) return dataISO;
  return `${dia}/${mes}/${ano}`;
}

export function calcularIdadeDias(dataFabricacao, dataEnsaio) {
  if (!dataFabricacao || !dataEnsaio) return "";
  const inicio = new Date(`${dataFabricacao}T00:00:00`);
  const fim = new Date(`${dataEnsaio}T00:00:00`);
  const diff = fim.getTime() - inicio.getTime();
  if (!Number.isFinite(diff)) return "";
  return Math.max(0, Math.round(diff / 86400000));
}

export function novoBloco(index) {
  return {
    bloco: String(index + 1).padStart(2, "0"),
    massa: "",
    largura1: "",
    largura2: "",
    comprimento1: "",
    comprimento2: "",
    altura1: "",
    altura2: "",
    area: "",
    cargaRupturaTf: "",
    tensaoRupturaMpa: "",
    septo1: "",
    septo2: "",
    septo3: "",
    septo4: "",
    parede1: "",
    parede2: "",
    parede3: "",
    parede4: "",
    somaParedes: "",
    desvioRelacaoEsquadro1: "",
    desvioRelacaoEsquadro2: "",
    desvioRelacaoEsquadro: "",
    planezaFaces1: "",
    planezaFaces2: "",
    planezaFaces: "",
  };
}

export function criarBlocos(quantidade = 13) {
  return Array.from({ length: Number(quantidade) || 13 }, (_, index) => novoBloco(index));
}

export function novoBlocoAbsorcao(index) {
  return {
    bloco: String(index + 1).padStart(2, "0"),
    massaSeca: "",
    massaUmida: "",
    absorcao: "",
  };
}

export function criarBlocosAbsorcao(quantidade = 6) {
  return Array.from({ length: Number(quantidade) || 6 }, (_, index) => novoBlocoAbsorcao(index));
}

export function media(...valores) {
  const lista = valores.map(numero).filter((valor) => Number.isFinite(valor) && valor > 0);
  if (!lista.length) return "";
  return lista.reduce((total, valor) => total + valor, 0) / lista.length;
}

function mediaInformada(...valores) {
  const lista = valores
    .filter((valor) => valor !== "" && valor !== null && valor !== undefined)
    .map(numero)
    .filter((valor) => Number.isFinite(valor));
  if (!lista.length) return "";
  return lista.reduce((total, valor) => total + valor, 0) / lista.length;
}

export function calcularBloco(item, { dividirComprimentoArea = false } = {}) {
  const larguraMedia = media(item.largura1, item.largura2);
  const comprimentoMedia = media(item.comprimento1, item.comprimento2);
  const alturaMedia = media(item.altura1, item.altura2);
  const comprimentoArea = dividirComprimentoArea ? comprimentoMedia / 2 : comprimentoMedia;
  const area = larguraMedia && comprimentoArea ? larguraMedia * comprimentoArea : 0;
  const cargaInformada = numero(item.cargaRupturaTf);
  const cargaTf = Number.isFinite(cargaInformada) && cargaInformada > 0 ? cargaInformada : 0;
  const cargaN = cargaTf ? cargaTf * 9806.65 : 0;
  const tensao = cargaN && area ? cargaN / area : 0;
  const somaParedes =
    numero(item.parede1) + numero(item.parede2) + numero(item.parede3) + numero(item.parede4);
  const desvioMedia = mediaInformada(item.desvioRelacaoEsquadro1, item.desvioRelacaoEsquadro2);
  const planezaMedia = mediaInformada(item.planezaFaces1, item.planezaFaces2);

  return {
    ...item,
    larguraMedia: larguraMedia ? larguraMedia.toFixed(1) : "",
    comprimentoMedia: comprimentoMedia ? comprimentoMedia.toFixed(1) : "",
    alturaMedia: alturaMedia ? alturaMedia.toFixed(1) : "",
    area: area ? area.toFixed(0) : "",
    tensaoRupturaMpa: tensao ? tensao.toFixed(2) : "",
    somaParedes: somaParedes ? somaParedes.toFixed(1) : "",
    desvioRelacaoEsquadro: desvioMedia !== "" ? desvioMedia.toFixed(1) : item.desvioRelacaoEsquadro || "",
    planezaFaces: planezaMedia !== "" ? planezaMedia.toFixed(1) : item.planezaFaces || "",
  };
}

export function calcularBlocos(lista = [], opcoes = {}) {
  return lista.map((item) => calcularBloco(item, opcoes));
}

export function calcularBlocoAbsorcao(item) {
  const massaSeca = numero(item.massaSeca);
  const massaUmida = numero(item.massaUmida);
  const absorcao = massaSeca && massaUmida ? ((massaUmida - massaSeca) / massaSeca) * 100 : 0;

  return {
    ...item,
    absorcao: absorcao ? absorcao.toFixed(1) : "",
  };
}

export function calcularBlocosAbsorcao(lista = []) {
  return lista.map(calcularBlocoAbsorcao);
}

export function calcularResumo(lista = [], listaAbsorcao = [], opcoes = {}) {
  const blocos = calcularBlocos(lista, opcoes);
  const blocosAbsorcao = calcularBlocosAbsorcao(listaAbsorcao);

  const tensoes = blocos
    .map((item) => numero(item.tensaoRupturaMpa))
    .filter((valor) => Number.isFinite(valor) && valor > 0);

  const absorcoes = blocosAbsorcao
    .map((item) => numero(item.absorcao))
    .filter((valor) => Number.isFinite(valor) && valor > 0);

  return {
    resistenciaMinima: tensoes.length
      ? Math.min(...tensoes).toFixed(2)
      : "",

    resistenciaMedia: tensoes.length
      ? (tensoes.reduce((total, valor) => total + valor, 0) / tensoes.length).toFixed(1)
      : "",

    absorcaoMedia: absorcoes.length
      ? (absorcoes.reduce((total, valor) => total + valor, 0) / absorcoes.length).toFixed(1)
      : "",
  };
}
